export default class CardComment extends HTMLDivElement {

    constructor() {
        super();
        this.toggleBtn = null;
        this.footerInfos = null;
        this.originalText = '';
    }

    connectedCallback() {
        this.toggleBtn = this.querySelector('a.btn');
        this.footerInfos = this.querySelector('.footer-infos');

        if (this.toggleBtn && this.footerInfos) {
            this.originalText = this.toggleBtn.textContent.trim();
            this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
        }
    }

    handleToggle(e) {
        e.preventDefault();
        this.footerInfos.classList.toggle('opened');

        if (this.footerInfos.classList.contains('opened')) {
            this.toggleBtn.textContent = 'Masquer le d\u00E9tail';
        } else {
            this.toggleBtn.textContent = this.originalText;
        }
    }

}